module.exports = __webpack_public_path__ + "img/ko.6031b375.svg";